import { render, staticRenderFns } from "./ActionsPdfPlacement.vue?vue&type=template&id=074167f7"
import script from "./ActionsPdfPlacement.vue?vue&type=script&lang=js"
export * from "./ActionsPdfPlacement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports